(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MessageCustom', MessageCustom);

    MessageCustom.$inject = ['$resource', 'ENV'];

    function MessageCustom($resource, ENV) {


        var newMessageFromSupplier = function () {
            var resourceUrl = ENV.API_BASE_URL + 'api/new-message-from-supplier';
            return $resource(resourceUrl, {}, {}
            );
        };

        return {
            newMessageFromSupplier: newMessageFromSupplier

        };
    }
})();
